module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/blank-fbaaf7e9ebc4d439483f9055107e1184.svg";